import React from 'react';
import { Typography, Space } from 'antd';
import { SlideContainer } from './SlideContainer';
import fundoBeneficios from '../assets/SlideBeneficios2.jpg';
import { ISlidePropostaData } from '../interface';

const { Title, Paragraph } = Typography;

const listaBeneficios = [
  'Acesso rápido e confiável às informações financeiras de saldo de contas e empenhos do município;',
  'As pendências em Certidões, CAUC, entre outros itens, são detectadas muito mais rápido;',
  'Menor chance de perder recursos federais e estaduais;',
  'Facilita aos gestores a tomada de decisão no desenvolvimento de políticas públicas;',
  'Todas essas informações estão disponíveis para os gestores, em tempo real, na palma da mão.',
];

const IconeCheck: React.FC = () => (
  <svg
    viewBox="0 0 28 28"
    fill="none"
    style={{
      width: 44,
      height: 44,
      flexShrink: 0,
      marginTop: 2,
    }}
  >
    <path
      d="M4 14.5L10.5 21L24 6.5"
      stroke="#5ea31b"
      strokeWidth="4.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export interface SlideBeneficiosProps {
  data?: ISlidePropostaData;
  scale?: number;
}

export const SlideBeneficios: React.FC<SlideBeneficiosProps> = ({ data, scale = 1 }) => {
  return (
    <SlideContainer
      showFooterLogo={false}
      showWaves={false}
      noPadding={true}
      backgroundImage={fundoBeneficios}
      scale={scale}
      data={data}
    >
      <div
        style={{
          position: 'absolute',
          top: 65,
          left: '42%',
          width: '54%',
          height: 'calc(100% - 220px)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <div style={{ marginBottom: 40 }}>
          <Title
            level={1}
            italic
            style={{
              color: '#0077b6',
              fontSize: 50,
              fontWeight: 900,
              margin: 0,
              lineHeight: 1.15,
              letterSpacing: 0.5,
            }}
          >
            BENEFÍCIOS PARA CONTRATAR
          </Title>
          <Title
            level={1}
            italic
            style={{
              color: '#0077b6',
              fontSize: 50,
              fontWeight: 900,
              margin: 0,
              lineHeight: 1.15,
              letterSpacing: 0.5,
            }}
          >
            O APLICATIVO GOVFÁCIL
          </Title>
        </div>
        <Space direction="vertical" size={28} style={{ width: '100%' }}>
          {listaBeneficios.map((texto, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 20,
              }}
            >
              <IconeCheck />
              <Paragraph
                style={{
                  fontSize: 26,
                  fontWeight: 700,
                  color: '#0f172a',
                  margin: 0,
                  lineHeight: 1.35,
                  letterSpacing: -0.2,
                }}
              >
                {texto}
              </Paragraph>
            </div>
          ))}
        </Space>
      </div>
    </SlideContainer>
  );
};